import * as React from "react";
import Tab from "@mui/material/Tab";
import { EcoSystemFilter } from "./filter/EcoSystemFilter";
import { Fix } from "./filter/Fix";

export function TabForVoi({ filter, setFilter }: any) {
  return (
    <>
      <Tab
        style={ {
          margin: "0",
          padding: "0",
          backgroundColor: "white",
          borderRadius: "1",
          paddingRight: "12px",
          minWidth: "302px"
        } }
        label={ <EcoSystemFilter filter={ filter } setFilter={ setFilter } /> }
      />
      <Tab
        style={ {
          margin: "0",
          padding: "0",
          backgroundColor: "white",
          borderRadius: "1",
          paddingRight: "12px",
          minWidth: "302px"
        } }
        label={ <Fix filter={ filter } setFilter={ setFilter } /> }
      />
    </>
  );
}
